<template>
  <div>
    <vx-card class="mt-3">
      <vs-table
        :sst="true"
        @search="handleSearch"
        @change-page="handleChangePage"
        :data="zones"
        @sort="handleSort"
        v-model="selected"
        pagination
        max-items="10"
        search
      >
        <template slot="header">
          <vs-button
            @click="callAddZone()"
            style="margin-left:5px;margin-top:5px"
            icon-pack="feather"
            icon="icon-plus"
          >Add zone</vs-button>
        </template>
        <template slot="thead">
          <vs-th sort-key="name">No.</vs-th>
          <vs-th sort-key="name">Name</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">{{ indextr +1 }}</vs-td>
            <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-button
        
        style="margin:5px"
        @click="callEdit()"
        v-if="selected!=null"
        color="warning"
      >Edit</vs-button>
      <vs-button
        style="margin:5px"
        v-if="selected!=null"
        @click="openConfirm()"
        color="danger"
      >Delete</vs-button>
    </vx-card>
  </div>
</template>
<script>
import axios from "axios";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import MarkerClusterer from "@google/markerclusterer";
import gmapsInit from "@/gmap/gmaps";
import { SERVER_SYNC_INTERVAL, API_BASE_URL } from "@/constants";
import { lstat } from "fs";
import { mapState } from "vuex";
export default {
  data() {
    return {
      activeConfirm: false,
      activeManage: true,
      zones: [],
      selected: null,
      accessEmail: "",
      accessToken: ""
    };
  },
  watch: {
   
  },
  mounted() {
    this.$vs.loading();
    this.accessEmail = localStorage.getItem("accessEmail");
    this.accessToken = localStorage.getItem("accessToken");
    this.$store.dispatch("updateTitlePage", "Zones");

    axios
      .get(`${API_BASE_URL}/admin/zones.json`, {
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken
        }
      })
      .then(response => {
        this.zones = response.data;
        this.$vs.loading.close();
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
  },
  methods: {
    openConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "คุณต้องการที่จะลบข้อมูล zone นี้ใช่หรือไม่",
        accept: this.deleteZone
      });
    },
    acceptAlert() {
      this.$vs.notify({
        color: "danger",
        title: "Deleted image",
        text: "The selected image was successfully deleted"
      });
    },
    callAddZone(){

  let routeData = this.$router.resolve({ name: "Zone" });
      window.open(routeData.href, "_parent");
    },
    callEdit() {
      this.$store.dispatch("updateEditZone", this.selected);
      localStorage.setItem("updateEditZone", JSON.stringify(this.selected.url))
      let routeData = this.$router.resolve({ name: "EditZone" });
      window.open(routeData.href, "_parent");
    },
    selectZone() {
      axios
        .get(`${API_BASE_URL}/admin/zones.json`, {
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          console.log("zones : ", response.data);
          this.zones = response.data;
        })
        .catch(error => {
          console.log("Error call apis :", error);
        });
    },
    deleteZone() {
      axios
        .delete(`${API_BASE_URL}/admin/zones/${this.selected.id}.json`, {
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          this.$vs.notify({
            title: this.$t("Success"),
            text: this.$t("ลบข้อมูล สำเร็จ"),
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-alert-circle",
            time: 5000
          });
          this.selectZone();
        })
        .catch(error => {
          console.log("Delete Error : ", error);
          this.selectZone();
        });
    },
    handleSearch(searching) {
      let _print = `The user searched for: ${searching}\n`;
      this.$refs.pre.appendChild(document.createTextNode(_print));
    },
    handleChangePage(page) {
      let _print = `The user changed the page to: ${page}\n`;
      this.$refs.pre.appendChild(document.createTextNode(_print));
    },
    handleSort(key, active) {
      let _print = `the user ordered: ${key} ${active}\n`;
      this.$refs.pre.appendChild(document.createTextNode(_print));
    }
  },
  components: {
    VuePerfectScrollbar
  }
};
</script>
<style >
</style>